var render = function render(){var _vm=this,_c=_vm._self._c;return _c('status-message',{attrs:{"error":true,"message":_vm.message}})
}
var staticRenderFns = []

export { render, staticRenderFns }